import { Reducer } from 'redux';
import { ISystemStatusState } from '../../types/systemStatus.types';
import * as constants from '../constants/systemStatus.constants';

const initialState: ISystemStatusState = {
  item: null,
  loading: true,
  error: null,
};

const systemStatusReducer: Reducer = (state = initialState, action: any) => {
  const { data, type } = action;

  switch (type) {
    case constants.GET_SYSTEM_STATUS_REQUESTED:
    case constants.UPDATE_SYSTEM_STATUS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case constants.GET_SYSTEM_STATUS_SUCCEEDED:
      return {
        ...state,
        item: data,
        loading: false,
      };
    case constants.UPDATE_SYSTEM_STATUS_SUCCEEDED:
      return {
        ...state,
        item: data.data,
        loading: false,
      };
    case constants.GET_SYSTEM_STATUS_FAILED:
      return {
        ...state,
        loading: false,
        error: data,
      };
    default:
      return state;
  }
};

export default systemStatusReducer;
